<template>
  <div class="demo">
    <div>
      默认
      <SjDatePicker
        placeholder="default"
        class="datePicker"
        style="width: 200px;"
        appendToBody
        v-model="value1"
      />
      <SjDatePicker
        placeholder="mini"
        size="mini"
        class="datePicker"
        style="width: 200px;"
        v-model="value1"
      />
      <SjDatePicker
        placeholder="small"
        size="small"
        class="datePicker"
        style="width: 200px;"
        v-model="value1"
      />
      <SjDatePicker
        placeholder="middle"
        size="middle"
        class="datePicker"
        style="width: 200px;"
        v-model="value1"
      />
      <SjDatePicker
        placeholder="large"
        size="large"
        class="datePicker"
        style="width: 200px;"
        v-model="value1"
      />
    </div>
    <div>
      自定义显示格式
      <SjDatePicker
        appendToBody
        format="YYYY年M月D日"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value1"
      />
      自定义显示格式(函数)
      <SjDatePicker
        :format="format"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value1"
      />
      自定义值格式：{{ value15 }}
      <SjDatePicker
        valueFormat="timestamp"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value15"
      />
    </div>
    <div>
      范围选择
      <SjDatePicker
        appendToBody
        placeholder="开始日期 - 结束日期"
        range
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value2"
      />
      可清除时间
      <SjDatePicker
        clearable
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value3"
      />
      disabled
      <SjDatePicker
        disabled
        class="datePicker"
        style="width: 150px;"
        v-model="value3"
      />
    </div>
    <div>
      选择时刻
      <SjDatePicker
        appendToBody
        type="datetime"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value4"
      />
      默认时刻
      <SjDatePicker
        type="datetime"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        :defaultTime="['08:00:00']"
        v-model="value5"
      />
      时刻范围选择
      <SjDatePicker
        type="datetime"
        range
        class="datePicker"
        style="width: 320px;"
        v-model="value6"
      />
    </div>
    <div>
      选择周
      <SjDatePicker
        appendToBody
        type="week"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value7"
      />
      调整起始周
      <SjDatePicker
        type="week"
        :firstDayOfWeek="1"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value8"
      />
      ！周无范围选择
    </div>
    <div>
      选择月
      <SjDatePicker
        appendToBody
        type="month"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value9"
      />
      月范围选择
      <SjDatePicker
        type="month"
        range
        class="datePicker"
        style="width: 200px;"
        v-model="value10"
      />
    </div>
    <div>
      选择季度
      <SjDatePicker
        appendToBody
        type="quarter"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value11"
      />
      季度范围选择
      <SjDatePicker
        type="quarter"
        range
        class="datePicker"
        style="width: 260px;"
        v-model="value12"
      />
    </div>
    <div>
      选择半年
      <SjDatePicker
        appendToBody
        type="halfYear"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value13"
      />
      半年范围选择
      <SjDatePicker
        type="halfYear"
        range
        class="datePicker"
        style="width: 260px;"
        v-model="value14"
      />
    </div>
    <div>
      选择年
      <SjDatePicker
        appendToBody
        type="year"
        class="datePicker"
        style="width: 200px;margin-right: 20px;"
        v-model="value20"
      />
      年范围选择
      <SjDatePicker
        type="year"
        range
        class="datePicker"
        style="width: 260px;"
        v-model="value21"
      />
    </div>
    <div>
      单日期时刻范围选择
      <SjDatePicker
        appendToBody
        type="singleDatetime"
        class="datePicker"
        style="width: 320px;"
        placeholder="开始时间 - 结束时间"
        precision="minute"
        format="YYYY-MM-DD HH:mm"
        range
        v-model="value16"
      />
    </div>
    <div>
      时刻精度控制
      <SjDatePicker
        appendToBody
        placeholder="second"
        type="datetime"
        class="datePicker"
        precision="second"
        style="width: 200px;margin-right: 20px;"
        v-model="value17"
      />
      <SjDatePicker
        placeholder="minute"
        type="datetime"
        class="datePicker"
        precision="minute"
        style="width: 200px;margin-right: 20px;"
        v-model="value18"
      />
      <SjDatePicker
        placeholder="hour"
        type="datetime"
        class="datePicker"
        precision="hour"
        style="width: 200px;"
        v-model="value19"
      />
    </div>
    <div>
      点击下拉框中年、月选择日期
      <SjDatePicker
        appendToBody
        :enableInputChecker="true"
        placeholder="default"
        class="datePicker"
        style="width: 200px;"
        v-model="value1"
      />
    </div>
    <div>
      时间选择
      <SjDatePicker
        appendToBody
        placeholder="default"
        type="time"
        class="datePicker"
        style="width: 200px;"
        valueFormat="timestamp"
        v-model="value22"
      />
      <SjDatePicker
        placeholder="default"
        type="time"
        class="datePicker"
        style="width: 200px;"
        valueFormat="timestamp"
        v-model="value22"
      />
      <SjDatePicker
        placeholder="default"
        type="time"
        class="datePicker"
        style="width: 200px;"
        valueFormat="timestamp"
        range
        v-model="value23"
      />
    </div>
    <div>
      快捷方式
      <SjDatePicker
        shortcut
        :shortcutOptions="shortcutOptions1"
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value3"
      />
      范围选择快捷方式
      <SjDatePicker
        type="datetime"
        range
        shortcut
        :shortcutOptions="shortcutOptions2"
        class="datePicker"
        style="width: 320px;"
        v-model="value6"
      />
    </div>
    <div>
      多选天
      <SjDatePicker
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value24"
        multiple
      />
      多选周
      <SjDatePicker
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value25"
        type="week"
        multiple
      />
      多选月
      <SjDatePicker
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value26"
        type="month"
        multiple
      />
    </div>
    <div>
      多选季度
      <SjDatePicker
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value27"
        type="quarter"
        multiple
      />
      多选半年
      <SjDatePicker
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value28"
        type="halfYear"
        multiple
      />
      多选年
      <SjDatePicker
        class="datePicker"
        style="width: 150px;margin-right: 20px;"
        v-model="value29"
        type="year"
        multiple
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: null,
      value2: null,
      value3: null,
      value4: null,
      value5: null,
      value6: null,
      value7: null,
      value8: null,
      value9: null,
      value10: null,
      value11: null,
      value12: null,
      value13: null,
      value14: null,
      value15: null,
      value16: null,
      value17: null,
      value18: null,
      value19: null,
      value20: null,
      value21: null,
      value22: null,
      value23: null,
      value24: null,
      value25: null,
      value26: null,
      value27: null,
      value28: null,
      value29: null,
      shortcutOptions1: [
        {
          text: "今天",
          onClick: () => Date.now()
        }
      ],
      shortcutOptions2: [
        {
          text: "此刻",
          onClick: () => [Date.now(), Date.now()]
        }
      ]
    };
  },
  methods: {
    format(timestamp) {
      return timestamp;
    }
  }
};
</script>

<style lang="less" scoped>
.demo {
  .text("caption", "available");
  > * {
    display: flex;
    align-items: center;

    + * {
      margin-top: 20px;
      .datePicker {
        margin-left: 20px;
      }
    }
  }
}
</style>
